// import Cookies from 'js-cookie'
import {getItem, setItem, removeItem, getJsonItem, setJsonItem} from './util'
const options = {
  sameSite: 'none',
  secure: true,
}
const Cookies = {
  get: getItem,
  set: setItem,
  remove: removeItem,
}
const TokenKey = 'authorization'

export function getToken() {
  return Cookies.get(TokenKey) || '';
}

export function setToken(token) {
  return Cookies.set(TokenKey, token || '')
  // return Cookies.set(TokenKey, token, options)
}

export function getStore(key) {
  return Cookies.get(key)
}

export function setStore(key, value) {
  return Cookies.set(key, value)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeVisitedViews() {
  setJsonItem('visitedViews', [])
}
export function setCachedView(val) {
  setJsonItem('cachedViews', val)
}
export function removeCachedView() {
  setJsonItem('cachedViews', [])
}
export function getCachedView() {
  return getJsonItem('cachedViews') || []
}

